import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import SplashScreen from "../layout/SplashScreen";

export default function PrivateRouteAdmin() {
  const { isAuthenticated, userData } = useSelector((state) => state.auth);

  if (!userData) {
    return <SplashScreen loadingScreen />;
  }

  return isAuthenticated && userData.role === "admin" ? (
    <>
      <Outlet />
    </>
  ) : (
    <div style={{ minHeight: "100vh" }}>
      <Navigate to="/login" replace />
    </div>
  );
}
